import React, { Component } from "react";
import { connect } from "react-redux";
import cc from "countries-cities";
import {
  CheckBox,
  FormSelect,
  FormInput,
  ProjectListHeader,
  ActionWithPlus,
  Question,
} from "../../../components";
import { back, push } from "../../../actions/nav-actions";
import {
  fetchBasics,
  putBasics,
  putStackholders,
  putRecipient,
  putTarget,
  updateStudyCaseStatus,
} from "../../../api";
import { notify, getDictionary } from "../../../utils";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import { Constants } from "../../../defaults";
import Calendar from "rc-calendar";
import "rc-calendar/dist/rc-calendar.min.css";

const createSliderWithTooltip = Slider.createSliderWithTooltip;
const Range = createSliderWithTooltip(Slider.Range);

class Basics extends Component {
  state = {
    is_loading: false,
    error: undefined,
    query: "",
    start_date: new Date(),
    end_date: new Date(),
    countries: cc.getCountries().map((c) => ({ label: c, value: c })),
    cities: [],
    data: {},
    project: {},
    questionSubsection: "",
  };
  constructor(props) {
    super(props);
    this.updateBasics = this.updateBasics.bind(this);
    this.updateRecipient = this.updateRecipient.bind(this);
    this.updateStakcholders = this.updateStakcholders.bind(this);
    this.updateTarget = this.updateTarget.bind(this);
    this.getParams = this.getParams.bind(this);
    this.getQuestionsByTag = this.getQuestionsByTag.bind(this);
    this.client = getDictionary(props.dictionary);
    this.getText = this.getText.bind(this);
  }
  getText(tag, category = "basics") {
    return this.client.get(category, tag);
  }
  getParams() {
    return this.props.match.params || {};
  }
  componentDidMount() {
    this._loadData();
  }
  _loadData() {
    const params = this.getParams();
    this.setState({ is_loading: true, error: undefined }, () => {
      fetchBasics(this.props.user.token, params.organization, params.code)
        .then((data) => {
          let { project } = data;
          let start_date = this.state.start_date;
          let end_date = this.state.end_date;
          if (project.dates.length === 2) {
            console.log("dates ", project.dates);
            start_date = project.dates[0];
            end_date = project.dates[1];
          }
          let cities = [];
          if (project.geolocation.country) {
            cities = [];
          }

          this.setState({
            is_loading: false,
            data,
            start_date,
            end_date,
            cities,
          });
        })
        .catch((err) => {
          this.setState({ is_loading: false, error: err });
        });
    });
  }
  changeName(name) {
    let { project } = this.state.data;
    project.name = name;
    this.setState({ data: { ...this.state.data, project } });
  }
  changeDescription(description) {
    let { project } = this.state.data;
    project.description = description;
    this.setState({ data: { ...this.state.data, project } });
  }
  updateBasics() {
    const params = this.getParams();
    putBasics(this.props.user.token, params.organization, params.code, {
      ...this.state.data.project,
      dates: [this.state.start_date, this.state.end_date],
    })
      .then(this.updateRecipient)
      .then(this.updateTarget)
      .then(this.updateStakcholders)
      .then(() => notify("Informations", "Successfully updated!"))
      .catch((err) => notify("Error", err.message, "error"));
  }
  updateStakcholders() {
    const params = this.getParams();
    return putStackholders(
      this.props.user.token,
      params.organization,
      params.code,
      {
        ...this.state.data.stackholders,
      }
    );
  }
  updateRecipient() {
    const params = this.getParams();
    return putRecipient(
      this.props.user.token,
      params.organization,
      params.code,
      {
        ...this.state.data.recipient,
        questions: this.getQuestionsByTag("program-recipients"),
      }
    );
  }
  updateTarget() {
    const params = this.getParams();
    return putTarget(this.props.user.token, params.organization, params.code, {
      ...this.state.data.target,
      questions: this.getQuestionsByTag("target-population"),
    });
  }
  getQuestionsByTag(tag = "") {
    let { questions } = this.state.data;
    questions = questions.filter((q) => q.subsection === tag);
    return questions.length > 0 ? questions[0].questions : [];
  }
  updateStatus(status) {
    const params = this.getParams();
    updateStudyCaseStatus(this.props.user.token, params.code, status)
      .then((data) => {
        if (status == "draft") {
          notify("Informations", "Successfully mark as draft!");
        } else {
          notify("Informations", "Successfully published!");
        }
        this._loadData();
      })
      .catch((err) => notify("Error", err.message, "error"));
  }
  updateQuestion({ description, value }, index, type) {
    let { questions } = this.state.data;
    let sectionQuestion = questions.filter((q) => q.subsection === type)[0];
    sectionQuestion.questions[index].description = description;
    sectionQuestion.questions[index].value = value;
    questions.questions = questions
      .filter((q) => q.subsection !== type)
      .concat([sectionQuestion]);
    this.setState({
      data: {
        ...this.state.data,
        questions,
      },
    });
  }
  renderSaveButton = () => {
    return (
      <button
        className="btn btn-info"
        onClick={this.updateBasics.bind(this)}
        style={{ marginTop: 24, marginBottom: 24 }}
      >
        SAVE
      </button>
    );
  };
  render() {
    if (this.state.error) return <span>{this.state.error.message}</span>;
    if (!this.state.data.project || this.state.is_loading)
      return <span>Loading data...</span>;

    let self = this;
    let { project, recipient, target, stackholders, options } = this.state.data;
    let ages = [0, 100];
    if (recipient.age.length === 2) ages = [recipient.age[0], recipient.age[1]];
    let target_ages = [0, 100];
    if (target.age.length === 2) target_ages = [target.age[0], target.age[1]];

    return (
      <React.Fragment>
        <ProjectListHeader title="PROJECT TITLE" />
        <FormInput
          value={project.name}
          onChange={this.changeName.bind(this)}
          placeholder="Write title"
        />
        <ProjectListHeader title="SUMMARY OR DESCRIPTION" />
        <FormInput
          value={project.description}
          onChange={this.changeDescription.bind(this)}
          placeholder="Describe the key elements of your program in a few short sentences."
        />

        {this.renderSaveButton()}

        <div>
          {project.is_study_case && project.status == "draft" && (
            <button
              onClick={() => {
                this.updateStatus("published");
              }}
              className="btn btn-info"
              style={{ marginTop: 24, marginBottom: 24 }}
            >
              PUBLISH
            </button>
          )}
          {project.is_study_case && project.status == "published" && (
            <button
              onClick={() => {
                this.updateStatus("draft");
              }}
              className="btn btn-warning"
              style={{ marginTop: 24, marginBottom: 24 }}
            >
              MARK AS DRAFT
            </button>
          )}
        </div>

        <ProjectListHeader title="DATES OF PROGRAM" />
        <div style={{ display: "flex", flexDirection: "row" }}>
          <Calendar
            value={moment(this.state.start_date)}
            selected={moment(this.state.start_date)}
            onChange={(date) => {
              this.setState({ start_date: date.toDate() });
            }}
          />
          <Calendar
            value={moment(this.state.end_date)}
            selected={moment(this.state.end_date)}
            onChange={(date) => {
              this.setState({ end_date: date.toDate() });
            }}
            className="end-date-calendar"
          />
        </div>

        {this.renderSaveButton()}

        <ProjectListHeader title="GEOLOCATION" />
        <div>
          <div className="row">
            <FormSelect
              onChange={(option) => {
                let { project } = this.state.data;
                project.geolocation.country = option.label;
                this.setState({
                  data: { ...this.state.data, project },
                  cities: [],
                });
              }}
              placeholder="Countries"
              searchable
              value={this.state.data.project.geolocation.country}
              options={this.state.countries}
              className="col-4"
            />
            <FormInput
              onChange={(text) => {
                let { project } = this.state.data;
                project.geolocation.cities = text.split(", ");
                this.setState({ data: { ...this.state.data, project } });
              }}
              placeholder="Cities"
              searchable
              multi
              containerClass="col-4"
              value={(this.state.data.project.geolocation.cities || []).join(
                ", "
              )}
            />
          </div>
          <FormInput
            value={project.geolocation.informations}
            onChange={(text) => {
              let { project } = this.state.data;
              project.geolocation.informations = text;
              this.setState({
                data: { ...this.state.data, project },
              });
            }}
            style={{ marginTop: 16 }}
            placeholder="Add aditional location information here"
          />
        </div>

        {this.renderSaveButton()}

        <ProjectListHeader
          dark={true}
          title="TYPE OF PROGRAM"
          description={this.getText("type_of_program_description")}
        />
        <div style={{ margin: "16px 4px" }}>
          <div>
            {options.types.map((type) => {
              return (
                <CheckBox
                  checked={
                    this.state.data.project.types.indexOf(type.id) !== -1
                  }
                  onChange={(value) => {
                    if (project.types.indexOf(value) === -1)
                      project.types = project.types.concat([value]);
                    else
                      project.types = project.types.filter((t) => t !== value);
                    self.setState({
                      data: { ...self.state.data, project },
                    });
                  }}
                  label={type.name}
                  key={type.id}
                  value={type.id}
                />
              );
            })}
          </div>
          <ActionWithPlus
            onClick={() => {
              this.props.push(
                `/projects/${this.props.match.params.organization}/${this.props.match.params.code}/types`
              );
            }}
            label="Add type of program"
          />
        </div>

        {this.renderSaveButton()}

        <ProjectListHeader
          dark={true}
          title="TARGET POPULATION"
          description={this.getText("target_population_description")}
        />
        <div>
          <FormSelect
            onChange={(option) => {
              let { target } = this.state.data;
              target.gender = option.value;
              this.setState({
                data: { ...this.state.data, target },
              });
            }}
            value={this.state.data.target.gender}
            placeholder="Gender"
            options={[
              { label: "Male", value: "male" },
              { label: "Female", value: "female" },
              { label: "Both", value: "both" },
            ]}
          />
          <div style={{ margin: "16px 0" }}>
            <div style={{ marginBottom: 16 }}>
              <p>
                Age Range. <br />
                Please use slider to state the age range.
              </p>
            </div>
            <span className="text-info">
              Actual age range {target_ages[0]}-{target_ages[1]}
            </span>
            <Range
              defaultValue={[target_ages[0], target_ages[1]]}
              onChange={(age) => {
                target.age = age;
                this.setState({
                  data: { ...this.state.data, target },
                });
              }}
              step={1}
            />
          </div>
          <p>
            If applicable:
            <br />
            You can select more than one option.
          </p>
          <FormSelect
            onChange={(sectors) => {
              let { target } = self.state.data;
              target.sectors = sectors.map((s) => s.value);
              this.setState({
                data: { ...this.state.data, target },
              });
            }}
            placeholder="Sectors"
            searchable
            multi
            style={{ marginBottom: 16 }}
            value={this.state.data.options.sectors
              .filter((g) => target.sectors.indexOf(g.id) !== -1)
              .map((s) => s.id)}
            options={this.state.data.options.sectors.map((s) => ({
              label: s.name,
              value: s.id,
            }))}
          />

          <div>
            {this.getQuestionsByTag("target-population").map(
              (question, index) => {
                return (
                  <Question
                    {...question}
                    onChange={(q) =>
                      this.updateQuestion(q, index, "target-population")
                    }
                  />
                );
              }
            )}
          </div>

          <ActionWithPlus
            onClick={() => {
              this.props.push(
                `/projects/${this.props.match.params.organization}/${this.props.match.params.code}/questions/target-population`
              );
            }}
            label="Add question"
          />
        </div>

        {this.renderSaveButton()}

        <ProjectListHeader
          dark={true}
          title="PROGRAM RECIPIENTS"
          description={this.getText("recipients_of_the_program_description")}
        />
        <div>
          <div className="row">
            <FormInput
              value={recipient.participants}
              onChange={(option) => {
                let { recipient } = this.state.data;
                recipient.participants = option;
                this.setState({
                  data: { ...this.state.data, recipient },
                });
              }}
              className="col-6"
              placeholder="Number of Participants"
            />
            <FormSelect
              onChange={(option) => {
                let { recipient } = this.state.data;
                recipient.gender = option.value;
                this.setState({
                  data: { ...this.state.data, recipient },
                });
              }}
              value={this.state.data.recipient.gender}
              placeholder="Gender"
              className="col-6"
              options={[
                { label: "Male", value: "male" },
                { label: "Female", value: "female" },
                { label: "Both", value: "both" },
              ]}
            />
          </div>
          <div style={{ margin: "16px 0" }}>
            <div style={{ marginBottom: 16 }}>
              <p>
                Age Range. <br />
                Please use slider to state the age range.
              </p>
            </div>
            <span className="text-info">
              Actual age range {ages[0]}-{ages[1]}
            </span>
            <Range
              defaultValue={[ages[0], ages[1]]}
              onChange={(age) => {
                recipient.age = age;
                this.setState({
                  data: { ...this.state.data, target },
                });
              }}
              step={1}
            />
          </div>
          <p>
            If applicable:
            <br />
            You can select more than one option.
          </p>
          <FormSelect
            onChange={(sectors) => {
              let { recipient } = self.state.data;
              recipient.sectors = sectors.map((s) => s.value);
              this.setState({
                data: { ...this.state.data, recipient },
              });
            }}
            placeholder="Sectors"
            searchable
            multi
            style={{ marginBottom: 16 }}
            value={this.state.data.options.sectors
              .filter((g) => recipient.sectors.indexOf(g.id) !== -1)
              .map((s) => s.id)}
            options={this.state.data.options.sectors.map((s) => ({
              label: s.name,
              value: s.id,
            }))}
          />

          <div>
            {this.getQuestionsByTag("program-recipients").map(
              (question, index) => {
                return (
                  <Question
                    {...question}
                    onChange={(q) =>
                      this.updateQuestion(q, index, "program-recipients")
                    }
                  />
                );
              }
            )}
          </div>

          <ActionWithPlus
            onClick={() => {
              this.props.push(
                `/projects/${this.props.match.params.organization}/${this.props.match.params.code}/questions/program-recipients`
              );
            }}
            label="Add question"
          />
        </div>

        {this.renderSaveButton()}

        <ProjectListHeader
          dark={true}
          title="ENTRY POINT"
          description={this.getText("entry_point_description")}
        />
        <div>
          {Constants.ENTRY_POINTS.map((entry, index) => {
            if (!project.entry_point.types) {
              project.entry_point.types = [];
            }
            let actual_type = project.entry_point.types.filter(
              (t) => t === entry.value
            )[0];
            const style = actual_type ? "text-info" : "text-muted";
            return (
              <p>
                <a
                  href="#!"
                  key={index}
                  onClick={(event) => {
                    event.preventDefault();
                    let { project } = this.state.data;
                    if (!actual_type)
                      project.entry_point.types = project.entry_point.types.concat(
                        [entry.value]
                      );
                    else
                      project.entry_point.types = project.entry_point.types.filter(
                        (t) => t !== entry.value
                      );
                    this.setState({
                      data: { ...this.state.data, project },
                    });
                  }}
                  style={{}}
                >
                  <span className={style}>{entry.label}</span>
                </a>
                <br />
              </p>
            );
          })}
          <FormInput
            value={project.entry_point.description}
            onChange={(description) => {
              let { project } = this.state.data;
              project.entry_point.description = description;
              this.setState({
                data: { ...this.state.data, project },
              });
            }}
            style={{ marginTop: 16 }}
            placeholder="Write relation"
          />
        </div>

        {this.renderSaveButton()}

        <ProjectListHeader dark={true} title="STAKEHOLDERS" />
        <div>
          <p>{this.getText("stackholders_monitoring_question")}</p>
          <FormInput
            style={{ marginTop: 8 }}
            placeholder=""
            value={stackholders.questions.monitoring}
            onChange={(monitoring) => {
              let { stackholders } = this.state.data;
              stackholders.questions.monitoring = monitoring;
              this.setState({
                data: { ...this.state.data, stackholders },
              });
            }}
          />
        </div>

        <div>
          {options.stackholders.map((stackholder, index) => {
            let style = "text-muted";
            let actual_stackholder = stackholders.stackholders.filter(
              (s) => s.stackholder === stackholder.id
            )[0];
            if (actual_stackholder) {
              style = "text-info";
            }
            return (
              <React.Fragment>
                <a
                  href="#!"
                  key={stackholder.id}
                  onClick={(event) => {
                    event.preventDefault();
                    let { stackholders } = this.state.data;
                    if (!actual_stackholder)
                      stackholders.stackholders = stackholders.stackholders.concat(
                        [{ stackholder: stackholder.id }]
                      );
                    else
                      stackholders.stackholders = stackholders.stackholders.filter(
                        (t) => t.stackholder !== stackholder.id
                      );
                    this.setState({
                      data: { ...this.state.data, stackholders },
                    });
                  }}
                >
                  <span className={style}>{stackholder.name}</span>
                </a>
                <br />
                <br />
              </React.Fragment>
            );
          })}
          <ActionWithPlus
            style={{ marginTop: 16 }}
            onClick={() => {
              this.props.push(
                `/projects/${this.props.match.params.organization}/${this.props.match.params.code}/stackholders`
              );
            }}
            label="Add Stakeholder"
          />
        </div>

        {this.renderSaveButton()}

        <div>
          {stackholders.stackholders.map((stackholder, index) => {
            let stackholder_name = options.stackholders.filter(
              (s) => s.id === stackholder.stackholder
            )[0];
            stackholder_name = stackholder_name
              ? stackholder_name.name
              : "Stackholder not recognized";
            return (
              <div key={index} style={{ marginHorizontal: 24 }}>
                <br />
                <span style={{ marginBottom: 8 }}>{stackholder_name}</span>
                <br />
                <span className="text-info">
                  {this.getText("stackholders_care_question")}
                </span>
                <FormInput
                  style={{ marginTop: 8 }}
                  value={stackholder.care}
                  onChange={(care) => {
                    let { stackholders } = this.state.data;
                    stackholder.care = care;
                    this.setState({
                      data: { ...this.state.data, stackholders },
                    });
                  }}
                  placeholder=""
                />

                <span className="text-info">
                  {this.getText("stackholders_decisions_question")}
                </span>
                <FormInput
                  value={stackholder.decisions}
                  style={{ marginTop: 8 }}
                  onChange={(decisions) => {
                    let { stackholders } = this.state.data;
                    stackholder.decisions = decisions;
                    this.setState({
                      data: { ...this.state.data, stackholders },
                    });
                  }}
                  placeholder=""
                />

                <span className="text-info">
                  {this.getText("stackholders_results_question")}
                </span>
                <FormInput
                  value={stackholder.results}
                  style={{ marginTop: 8 }}
                  onChange={(results) => {
                    let { stackholders } = this.state.data;
                    stackholder.results = results;
                    this.setState({
                      data: { ...this.state.data, stackholders },
                    });
                  }}
                  placeholder=""
                />

                <span className="text-info">
                  {this.getText("stackholders_make_decisions_question")}
                </span>
                <FormInput
                  value={stackholder.make_decisions}
                  onChange={(make_decisions) => {
                    let { stackholders } = this.state.data;
                    stackholder.make_decisions = make_decisions;
                    this.setState({
                      data: { ...this.state.data, stackholders },
                    });
                  }}
                  style={{ marginTop: 8 }}
                  placeholder=""
                />
              </div>
            );
          })}
        </div>

        {this.renderSaveButton()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state.localStorage,
  user: state.authReducer.user,
});

const mapDispatchToProps = (dispatch) => ({
  back() {
    dispatch(back());
  },
  push(routeName) {
    dispatch(push(routeName));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Basics);



// WEBPACK FOOTER //
// ./src/routers/Projects/Formularies/BasicsFormularies.js